// extracted by mini-css-extract-plugin
export default {"contents":"dG-z","sectionHeading":"eG-z"};